// export default ProductMap = {
exports.ProductMap = {
  53: {
    '2 kWh': [{
      name: 'Kit Get Set (2kWh)',
      pid: '7749275320542',
      varId: '43223158915294',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3898',
      old_price: '4898',
      save_money: '1000',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '1 batería LFP de 2kWh', '1 juego de cables'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'El kit Get Set te permite crear rápidamente un sistema eléctrico básico para tu furgoneta cámper/hogar sin conexión a la red eléctrica usando una batería LFP y un Power Hub.'
    }, {
      name: 'Kit preparado (2kWh)',
      pid: '7749275320542',
      varId: '43223158948062',
      adaptBatCap: '2-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4398',
      old_price: '5468',
      save_money: '1070',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '1 batería LFP de 2kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 correa de montaje de batería'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'El Kit preparado te permite controlar mejor tu uso de la energía, ofreciéndote la máxima comodidad mientras viajas o si vives en un lugar sin conexión a la red eléctrica.'
    }, {
      name: 'Kit de independencia energética (2kWh)',
      pid: '7749275320542',
      varId: '43223158980830',
      adaptBatCap: '2-1',
      limit: 2,
      off_price: '4698',
      old_price: '5798',
      save_money: '1100',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '1 batería LFP de 2kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 Consola del Power Kits',
      // '1 x Smart Generator',
      '1 correa de montaje de batería'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'El Kit de independencia energética proporciona una solución completa para disponer de energía sin estar conectado a la red eléctrica. Con la ayuda del panel de distribución inteligente CA/CC y la consola del Power Kit de EcoFlow puedes supervisar, controlar y personalizar tu energía desde la pared o la aplicación móvil.'
    }],
    '4 kWh': [{
      name: 'Kit Get Set (4kWh)',
      pid: '7749275451614',
      varId: '43223159275742',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5597',
      old_price: '7097',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '2 baterías LFP de 2kWh', '1 juego de cables'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'El kit Get Set te permite crear rápidamente un sistema eléctrico básico para tu furgoneta cámper/hogar sin conexión a la red eléctrica usando una batería LFP y un Power Hub.'
    }, {
      name: 'Kit preparado (4kWh)',
      pid: '7749275451614',
      varId: '43223159341278',
      adaptBatCap: '2-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6097',
      old_price: '7667',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '2 baterías LFP de 2kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '2 correa de montaje de baterías'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'El Kit preparado te permite controlar mejor tu uso de la energía, ofreciéndote la máxima comodidad mientras viajas o si vives en un lugar sin conexión a la red eléctrica.'
    }, {
      name: 'Kit de independencia energética (4kWh)',
      pid: '7749275451614',
      varId: '43223159374046',
      adaptBatCap: '2-1',
      limit: 1,
      off_price: '6397',
      old_price: '7997',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '2 baterías LFP de 2kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 Consola del Power Kits',
      // '1 x Smart Generator',
      '2 correa de montaje de baterías'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'El Kit de independencia energética proporciona una solución completa para disponer de energía sin estar conectado a la red eléctrica. Con la ayuda del panel de distribución inteligente CA/CC y la consola del Power Kit de EcoFlow puedes supervisar, controlar y personalizar tu energía desde la pared o la aplicación móvil.'
    }],
    '5 kWh': [{
      name: 'Kit Get Set (5kWh)',
      pid: '7749275484382',
      varId: '43223159570654',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5998',
      old_price: '7498',
      save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '1 batería LFP de 5kWh', '1 juego de cables'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'El kit Get Set te permite crear rápidamente un sistema eléctrico básico para tu furgoneta cámper/hogar sin conexión a la red eléctrica usando una batería LFP y un Power Hub.'
    }, {
      name: 'Kit preparado (5kWh)',
      pid: '7749275484382',
      varId: '43223159603422',
      adaptBatCap: '5-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6498',
      old_price: '8068',
      save_money: '1570',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '1 batería LFP de 5kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 correa de montaje de batería'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'El Kit preparado te permite controlar mejor tu uso de la energía, ofreciéndote la máxima comodidad mientras viajas o si vives en un lugar sin conexión a la red eléctrica.'
    }, {
      name: 'Kit de independencia energética (5kWh)',
      pid: '7749275484382',
      varId: '43223159636190',
      adaptBatCap: '5-1',
      limit: 2,
      off_price: '6798',
      old_price: '8398',
      save_money: '1600',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '1 batería LFP de 5kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 Consola del Power Kits',
      // '1 x Smart Generator',
      '1 correa de montaje de batería'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'El Kit de independencia energética proporciona una solución completa para disponer de energía sin estar conectado a la red eléctrica. Con la ayuda del panel de distribución inteligente CA/CC y la consola del Power Kit de EcoFlow puedes supervisar, controlar y personalizar tu energía desde la pared o la aplicación móvil.'
    }],
    '10 kWh': [{
      name: 'Kit Get Set (10kWh)',
      pid: '7749275549918',
      varId: '43223159865566',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '9797',
      old_price: '12297',
      save_money: '2500',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '2 baterías LFP de 5kWh', '1 juego de cables'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'El kit Get Set te permite crear rápidamente un sistema eléctrico básico para tu furgoneta cámper/hogar sin conexión a la red eléctrica usando una batería LFP y un Power Hub.'
    }, {
      name: 'Kit preparado (10kWh)',
      pid: '7749275549918',
      varId: '43223159931102',
      adaptBatCap: '5-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '10297',
      old_price: '12867',
      save_money: '2570',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '2 baterías LFP de 5kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '2 correa de montaje de baterías'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'El Kit preparado te permite controlar mejor tu uso de la energía, ofreciéndote la máxima comodidad mientras viajas o si vives en un lugar sin conexión a la red eléctrica.'
    }, {
      name: 'Kit de independencia energética (10kWh)',
      pid: '7749275549918',
      varId: '39946340565065',
      adaptBatCap: '5-1',
      limit: 1,
      off_price: '10597',
      old_price: '13197',
      save_money: '2600',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '2 baterías LFP de 5kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 Consola del Power Kits',
      // '1 x Smart Generator',
      '2 correa de montaje de baterías'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'El Kit de independencia energética proporciona una solución completa para disponer de energía sin estar conectado a la red eléctrica. Con la ayuda del panel de distribución inteligente CA/CC y la consola del Power Kit de EcoFlow puedes supervisar, controlar y personalizar tu energía desde la pared o la aplicación móvil.'
    }],
    '15 kWh': [{
      name: 'Kit Get Set (15kWh)',
      pid: '7749275615454',
      varId: '43223160226014',
      consoleChoose: 'Y',
      off_price: '13596',
      old_price: '17096',
      save_money: '3500',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '3 baterías LFP de 5kWh', '1 juego de cables'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'El kit Get Set te permite crear rápidamente un sistema eléctrico básico para tu furgoneta cámper/hogar sin conexión a la red eléctrica usando una batería LFP y un Power Hub.'
    }, {
      name: 'Kit preparado (15kWh)',
      pid: '7749275615454',
      varId: '43223160258782',
      consoleChoose: 'Y',
      off_price: '14096',
      old_price: '17666',
      save_money: '3570',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '3 baterías LFP de 5kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '3 correa de montaje de baterías'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'El Kit preparado te permite controlar mejor tu uso de la energía, ofreciéndote la máxima comodidad mientras viajas o si vives en un lugar sin conexión a la red eléctrica.'
    }, {
      name: 'Kit de independencia energética (15kWh)',
      pid: '7749275615454',
      varId: '43223160291550',
      off_price: '14396',
      old_price: '17996',
      save_money: '3600',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Principios de agosto de 2022',
      accessories: ['1 Power Hub', '3 baterías LFP de 5kWh', '1 juego de cables', '1 panel de distribución inteligente CA/CC', '1 Consola del Power Kits',
      // '1 x Smart Generator',
      '3 correa de montaje de baterías'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'El Kit de independencia energética proporciona una solución completa para disponer de energía sin estar conectado a la red eléctrica. Con la ayuda del panel de distribución inteligente CA/CC y la consola del Power Kit de EcoFlow puedes supervisar, controlar y personalizar tu energía desde la pared o la aplicación móvil.'
    }]
  }
};
exports.solarPanelMap = {
  53: [{
    name: '2 * Panel solar rígido de 100 W + 2 * Patas de montaje solar rígido',
    pid: '7784296120542',
    varId: '43361967636702',
    old_price: '229',
    off_price: '179',
    save_money: '50',
    limit: 99,
    // discount: "%1=229%%2=449%%3=649%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2 * Panel solar rígido de 400 W + 4 * Patas de montaje solar rígido',
    pid: '7856793419998',
    varId: '43593399828702',
    old_price: '799',
    off_price: '599',
    save_money: '200',
    limit: 99,
    // tips: '*This item excludes free shipping.',
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1 * Panel solar flexible de 100 W',
    pid: '7784277835998',
    varId: '43361884864734',
    old_price: '149',
    off_price: '129',
    save_money: '20',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }
  // {
  //     name: '1*400W Portable Solar Panel',
  //     pid: '6618094960713',
  //     varId: '39998021697609',
  //     old_price: '1199',
  //     off_price: '1199',
  //     // save_money: '0',
  //     limit: 99,
  //     imgSrc: '/img/mm100/preview/flexibel-400w.jpg',
  // },
  ]
};

exports.BatteryMap = {
  53: [{
    name: 'Batería LFP de 2 kWh + Soporte de montaje + Cable de batería',
    pid: '7854292566238',
    varId: '43586035220702',
    off_price: '1748',
    old_price: '2248',
    save_money: '500',
    capacity: '2-1',
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: 'Batería LFP de 5 kWh + Soporte de montaje + Cable de batería',
    pid: '7854292566238',
    varId: '43586035253470',
    off_price: '3848',
    old_price: '4848',
    save_money: '1000',
    capacity: '5-1',
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }
  // {
  //     name: 'baterías LFP de 2kWh',
  //     pid: '7854292566238',
  //     varId: '43586035122398',
  //     off_price: '1699',
  //     old_price: '2199',
  //     save_money: '500',
  //     capacity: 2,
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: 'baterías LFP de 5kWh',
  //     pid: '7854292566238',
  //     varId: '43586035253470',
  //     off_price: '3799',
  //     old_price: '4799',
  //     save_money: '1000',
  //     capacity: 5,
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  // {
  //     name: 'baterías LFP de 2kWh + correa de montaje de batería',
  //     pid: '7854292566238',
  //     varId: '43586035220702',
  //     off_price: '1748',
  //     old_price: '2248',
  //     save_money: '500',
  //     capacity: '2-1',
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: 'baterías LFP de 5kWh + correa de montaje de batería',
  //     pid: '7854292566238',
  //     varId: '43586035155166',
  //     off_price: '3848',
  //     old_price: '4848',
  //     save_money: '1000',
  //     capacity: '5-1',
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  ]
};

// exports.InstallationMap = {
//     53: {
//         pid: '8454960283995',
//         varId: '46803353829723',
//         off_price: '0',
//         old_price: '0',
//         save_money: '0',
//     },
// };

exports.ConsoleMap = {
  53: [{
    name: 'Consola de EcoFlow Power Kits',
    pid: '7727416279262',
    varId: '43118027833566',
    off_price: '349',
    old_price: '349',
    limit: 1,
    // save_money: '599',
    // beDepNodeName: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};

// exports.SmartGenerator = {
//     "3": [
//         {
//             name: "Smart Generator with Smart Generator Adapter",
//             pid: "6797293715529",
//             varId: "40086547759177",
//             off_price: '1300',
//             old_price: '1468',
//             limit: 99,
//             save_money: '168',
//             // depNodeName: 'console',
//             imgSrc: "/img/calculators/mm100/combo-generator.jpg"
//         }
//     ]
// }

exports.ShopifyUrl = 'https://es.ecoflow.com/';